import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { api } from 'src/environments/environment';
import { UsuarioCognito } from '../interfaces/usuario_cognito.interface';

const HEADERS = new HttpHeaders({
    'Content-Type': 'application/json'
});

@Injectable({
    providedIn: 'root'
})
export class CognitoUsuarioService {

    URL = `${api.urlAPI}` + 'api/adm/ss/';

    constructor(private http: HttpClient) { }

    enabledUsuarioCognito(usuario: UsuarioCognito) {
        return this.http.put(this.URL + 'cognito/enabled', usuario, { headers: HEADERS });
    }

    disabledUsuarioCognito(usuario: UsuarioCognito) {
        return this.http.put(this.URL + 'cognito/disabled', usuario, { headers: HEADERS });
    }

    resetUsuarioCognito(usuario: UsuarioCognito) {
        return this.http.put(this.URL + 'cognito/reset', usuario, { headers: HEADERS });
    }

    resendUsuarioCognito(usuario: UsuarioCognito): Observable<UsuarioCognito> {
        return this.http.put<UsuarioCognito>(this.URL + 'resend', usuario, { headers: HEADERS });
    }

    deleteUsuarioCognito(cveUser: string) {
        return this.http.delete(this.URL + 'cognito/' + cveUser, { headers: HEADERS });
    }

}
